<template>
  <div>
    <v-row>
      <v-col cols="12" class="py-1">
        <v-toolbar color="transparent" flat>
          <v-toolbar-title class="headline-header text-h6 px-0">
            {{ title }}
          </v-toolbar-title>
          <v-spacer />
        </v-toolbar>
      </v-col>
    </v-row>
    <v-divider class="pb-2 divider-header" />
    <v-card>
      <v-form v-model="valid" lazy-validation @submit.prevent="submit" ref="form">
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="12" class="py-0">
                <v-autocomplete
                  label="Tipo de Relatório"
                  v-model="formData.tipo"
                  :items="tipos"
                  outlined
                  hide-no-data
                  hide-selected
                  placeholder="Selecione o tipo para consultar"
                  clearable
                  dense
                  :rules="rules.tipo"
                  :error-messages="errors.tipo"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!valid"
            depressed
            :loading="isloadingSubmit"
            color="green"
            dark
            type="submit"
          >
            <v-icon small left>mdi-send</v-icon>
            Buscar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <PDF />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import PDF from '@/views/public/modal/Pdf.vue';
import relatoriosHttp from '@/services/http/resources/configuracao/relatoriosHttp';
import toastMessage from '@/services/util/alertService';
import { required } from '@/services/util/validate';

export default {
  name: 'RelatorioVeiculosAusenciaDados',
  components: {
    PDF,
  },
  metaInfo: {
    title: 'Relatórios Veículos com Ausencia de Informações',
    titleTemplate: `%s | ${process.env.VUE_APP_TITLE}`,
  },
  data: () => ({
    valid: true,
    title: 'Relatórios Veículos com Ausencia de Informações',
    tipos: [
      { value: 'foto', text: 'Relatório sem Foto' },
      { value: 'lotacao', text: 'Relatório sem Lotação' },
      { value: 'motorista', text: 'Relatório sem Motorista' },
      { value: 'rota', text: 'Relatório sem Rota' },
      { value: 'documento', text: 'Relatório sem Documento' },
    ],
    formData: {
      tipo: '',
    },
    rules: {
      tipo: [required],
    },
    errors: {
      tipo: [],
    },
    isloadingSubmit: false,
  }),
  methods: {
    ...mapActions('app', ['toggleModalPdf']),
    resetValidation() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.isloadingSubmit = true;
        relatoriosHttp
          .veiculosAusenciaDados(this.formData)
          .then(({ data }) => {
            const file = new Blob([data], { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(file);
            this.toggleModalPdf(fileURL);
          })
          .catch(() => toastMessage.errorLoading('Erro ao carregar documento.'))
          .finally(() => {
            this.isloadingSubmit = false;
          });
      }
    },
  },
  watch: {
    'formData.tipo': function () {
      this.errors.tipo = [];
    },
  },
  destroyed() {
    this.resetValidation();
  },
};
</script>

<style></style>
